module.exports = __webpack_public_path__ + "static/img/pro9_tab2.f323a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro9_tab2.jpg
// module id = G7VT
// module chunks = 171